import React, { useState } from "react";
import { Button, Menu, Modal, Popup } from "semantic-ui-react";
import WikiDocList from "./WikiDocList";
import WikiDocReorder from "./WikiDocReorder";

const WikiDocumentModal = (props) => {
  const [reorder, setReorder] = useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const [save, setSave] = useState(false);

  const handleReorder = () => {
    reorder && setReorder(false);
    !reorder && setReorder(true);
  };

  return (
    <Modal
      size="tiny"
      onClose={() => props.setOpen(false)}
      onOpen={() => props.setOpen(true)}
      open={props.open}
    >
      <Modal.Content scrolling className="eventVisitorModal tab-modal">
        <div className="eventVisitorModalButton">
          <Button
            floated="left"
            circular
            icon="close"
            onClick={() => props.setOpen(false)}
          />
          <div>
            {!reorder ? (
              <>
                <Button icon circular color="blue" onClick={() => {}}>
                  {props.wiki.wikis.length < 10 ? "0" : ""}
                  {props.wiki.wikis && props.wiki.wikis.length}
                </Button>
                <Popup
                  content="Reorder"
                  trigger={
                    <Button
                      icon="sort amount up"
                      circular
                      color="teal"
                      onClick={handleReorder}
                    />
                  }
                />
              </>
            ) : (
              <>
                <Popup
                  content="Save"
                  trigger={
                    <Button
                      icon="checkmark"
                      circular
                      color="green"
                      onClick={() => setSave(true)}
                    />
                  }
                />
                <Popup
                  content="Close"
                  trigger={
                    <Button
                      icon="close"
                      disabled={changesMade}
                      circular
                      color="red"
                      onClick={handleReorder}
                    />
                  }
                />
              </>
            )}
          </div>
        </div>

        <div className="list">
          <Menu className="cu-tab" pointing secondary>
            <Menu.Item name="Documents" active className="inner-link" />
          </Menu>
          {!reorder ? (
            <WikiDocList documents={props.wiki.wikisData} wiki={props.wiki} />
          ) : (
            <WikiDocReorder
              documents={props.wiki.wikisData}
              setReorderOff={() => setReorder(false)}
              changesMade={(e) => setChangesMade(e)}
              handleSave={save}
              handleSaveState={(e) => setSave(e)}
            />
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default WikiDocumentModal;
